(function() {
    function AudienceRatingFormatter() {
        var score = "";
        return function(rating) {
            if (_.isNull(rating) || _.isUndefined(rating)) {
                return score;
            } else {
                switch (true) {
                    case (rating < 50):
                        score = "audiencebad.png";
                        break;
                    case (rating >= 50):
                        score = "audiencegood.png";
                        break;
                }

                return score;
            }
        };
    }
    AudienceRatingFormatter.$inject = [];
    angular
        .module("cstudioApp.filters")
        .filter("AudienceRatingFormatter", AudienceRatingFormatter);
})();